import { Article, ArticleService } from '../../article';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';


@Component({
    selector: 'app-article',
    templateUrl: './article.component.html',
    styleUrls: ['./article.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ArticleComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private articleService: ArticleService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.article = data?.article,
			this.statuses = articleService.statuses;
			
	}

	@Input() article: Article;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	articleId: number;
	pageStartDate: Date;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'articleId': [],
		'pageTitle': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'linkDescription': [],	
		'pageStartDate': [],
		'pageEndDate': [],
		'pageHtml': [],
		'pageText': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole article object
		if (this.article) {
			this.articleId = this.article.articleId;
			if(this.article.pageStartDate != undefined && this.article.pageStartDate != null){
				this.article.pageStartDate = moment(this.article.pageStartDate).toDate();
			}
			if(this.article.pageEndDate != undefined && this.article.pageEndDate != null){
				this.article.pageEndDate = moment(this.article.pageEndDate).toDate();
			}

			this.fixDates();
			

			this.form1.patchValue(this.article);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.articleId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.articleService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.article = res.data.article;
						this.doAdd.emit(this.article);
					},
					(err: any) => {
						console.log('article-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('article: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.articleService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.article = res.data.article;
						this.doUpdate.emit(this.article);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.articleService.delete(this.article.articleId)
				.subscribe(
					(res: any) => {
						console.log('article-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.article);
					},
					(err: any) => {
						console.log('article-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			articleId: [this.articleId],
			enteredByUserId: [this.article?.enteredByUserId],	
			pageTitle: [],
			linkDescription: [], 
			pageStartDate: [],
			pageEndDate: [],
			pageHtml: [],
			pageText: []
		});
	}

	

	fixDates() {
		// create date objects - why can't primeng do this?
		this.article.articleDate = moment(this.article.articleDate).toDate();
	}
	
}
